import React from "react";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import { Briefcase, Handshake, Users, ArrowRight } from "lucide-react";

const ENTERPRISE_IMG =
  "/assets/business-handshake.jpg";

const ACTIONS = [
  { icon: Briefcase, title: "Proposer des projets", text: "Confiez de vrais défis à nos étudiants." },
  { icon: Users, title: "Participer aux événements", text: "Conférences, ateliers, recrutement direct." },
  { icon: Handshake, title: "Recruter des talents", text: "Stages, alternance, premier emploi." },
];

export const Enterprise = () => {
  const navigate = useNavigate();
  return (
    <section
      id="enterprise"
      data-testid="enterprise-section"
      className="bg-white relative"
    >
      <div className="grid grid-cols-1 lg:grid-cols-2 min-h-[600px]">
        <motion.div
          initial={{ opacity: 0, x: -30 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.8 }}
          className="relative overflow-hidden zoom-frame min-h-[400px] lg:min-h-full"
        >
          <img src={ENTERPRISE_IMG} alt="Poignée de main entreprise" className="absolute inset-0 w-full h-full object-cover" />
        </motion.div>

        <div className="p-10 md:p-16 lg:p-20 flex flex-col justify-center bg-[#FAF8F3]">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-100px" }}
            transition={{ duration: 0.8 }}
          >
            <div className="overline mb-4 text-red-500">Espace entreprises</div>
            <h2 className="font-display text-2xl sm:text-3xl md:text-5xl text-navy-700 leading-tight mb-6">
              Recrutez les <em className="not-italic red-shine">talents de demain</em>.
            </h2>
            <p className="text-[#555] text-[16px] leading-relaxed mb-10">
              Nos étudiants sont opérationnels dès le premier jour. Trois manières
              simples de collaborer avec nous, pour faire émerger les leaders qui
              piloteront vos transformations.
            </p>

            <div className="space-y-px">
              {ACTIONS.map((a, i) => {
                const Icon = a.icon;
                return (
                  <div
                    key={a.title}
                    className="flex items-start gap-5 p-5 bg-white border border-navy-100 hover:border-navy-300 transition-all"
                    data-testid={`enterprise-action-${i}`}
                  >
                    <Icon className="h-7 w-7 text-red-500 shrink-0 mt-0.5" strokeWidth={1.5} />
                    <div>
                      <div className="font-display text-navy-700 text-lg">{a.title}</div>
                      <div className="text-[#666] text-sm">{a.text}</div>
                    </div>
                  </div>
                );
              })}
            </div>

            <button
              onClick={() => navigate("/contact")}
              className="btn-red mt-10"
              data-testid="enterprise-cta"
            >
              Devenir partenaire
              <ArrowRight className="h-4 w-4" />
            </button>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default Enterprise;
